import { useNavigate } from 'react-router-dom';
import { useAuth } from '@wlb/shared/context/AuthContext';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { BrandLogo } from '../components/ui/BrandLogo';
import { AuthFlowLayout } from '../components/layout/AuthFlowLayout';

export function WelcomeSurvey() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { completeAuthSession, token } = useAuth();

  /** Skipping the survey is one of the two exits that activate the session. */
  const enterApp = async (): Promise<void> => {
    navigate('/', { replace: true });
    await completeAuthSession(token ?? undefined);
  };

  return (
    <AuthFlowLayout>
      <div className="auth-flow__card auth-flow__welcome">
        <button className="auth-flow__skip" type="button" onClick={enterApp}>{t('survey.welcome.skip')}</button>
        <BrandLogo compact className="auth-flow__brand" />
        <div className="auth-flow__illustration" aria-hidden>WLB</div>
        <h1 className="auth-flow__heading">{t('survey.welcome.title')}</h1>
        <p className="auth-flow__subheading">{t('survey.welcome.subtitle')}</p>
        <button className="auth-flow__primary" type="button" onClick={() => navigate('/survey/q1')}>{t('common.buttons.getStarted')}</button>
        <button className="auth-flow__social" type="button" onClick={enterApp}>{t('common.buttons.doThisLater')}</button>
      </div>
    </AuthFlowLayout>
  );
}
